<template>
    <div tic="v0.0.1" class="app-box p-relative" :class="bgClass ? bgClass : ''" :style="!isMobile && bgImg ? 'background-image:url(' + bgImg + ');' : ''">
        <div v-if="isMobile && bgImg" class="d-none mobile-img-hack" :style="bgImg ? 'background-image:url(' + bgImg + ');' : ''"></div>
        <header id="header" v-if="!isHome || !isMobile" class="p-fixed w-100" :class="bgFullWrap ? '' : 'bg-white'">
            <div class="container d-flex space-between">
                <router-link class="pt-2" :class="isHome ? 'home-logo-link' : 'logo-link'" to="/">
                    <img v-if="(whiteTextHeader && !isMobile) || (isMobile && isHome)" class="logo" alt="halo logo" src="./assets/images/logo_white.png" />
                    <img v-else class="logo" alt="halo logo" src="./assets/images/logo.png" />
                </router-link>
                <a class="nav-toggle-btn p-absolute p-2" :class="isHome ? 'home-nav-toggle-btn' : ''" href="javascript:void(0);" @click="toggleMenu">
                    <svg v-if="menuOpen && !isHome" t="1648455760727" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11621" width="32" height="32"><path d="M557.312 513.248l265.28-263.904c12.544-12.48 12.608-32.704 0.128-45.248-12.512-12.576-32.704-12.608-45.248-0.128l-265.344 263.936-263.04-263.84C236.64 191.584 216.384 191.52 203.84 204 191.328 216.48 191.296 236.736 203.776 249.28l262.976 263.776L201.6 776.8c-12.544 12.48-12.608 32.704-0.128 45.248 6.24 6.272 14.464 9.44 22.688 9.44 8.16 0 16.32-3.104 22.56-9.312l265.216-263.808 265.44 266.24c6.24 6.272 14.432 9.408 22.656 9.408 8.192 0 16.352-3.136 22.592-9.344 12.512-12.48 12.544-32.704 0.064-45.248L557.312 513.248z" p-id="11622"></path></svg>
                    <svg v-else t="1648452894120" class="icon" :class="bgFullWrap ? 'fill-white' : ''" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6596" width="32" height="32">
                        <path d="M120 904c-31.2 0-56-24.8-56-56s24.8-56 56-56h784c31.2 0 56 24.8 56 56s-24.8 56-56 56H120z m0-336c-31.2 0-56-24.8-56-56s24.8-56 56-56h784c31.2 0 56 24.8 56 56s-24.8 56-56 56H120z m0-336c-31.2 0-56-24.8-56-56s24.8-56 56-56h784c31.2 0 56 24.8 56 56s-24.8 56-56 56H120z" p-id="21837" fill="#000000"></path>
                    </svg>
                </a>
                <div v-show="menuOpen" class="common-menu-box d-flex" :class="isHome ? 'home-menu-box' : 'page-menu-box'">
                    <nav id="nav" class="d-flex space-between common-menu nav nav-box font-willow-leaf">
                        <div :class="whiteTextHeader ? 'menu p-relative' : 'menu black-menu p-relative'">
                            <router-link class="hover-hl" to="/gallery">GALLERY</router-link>
                            <router-link class="hover-hl" to="/mint">MINT</router-link>
                            <router-link class="hover-hl" to="/haloworld_entry"><img src="./assets/images/hot_icon.png" /> HALOWORLD</router-link>
                            <router-link class="hover-hl" to="/halo_earn">HALO EARN</router-link>
                            <a class="hover-hl" target="_blank" href="https://market.lifeform.cc/">MARKET</a>
                            <a class="hover-hl" target="_blank" href="https://medium.com/@halonft.art-official/haloworld-whitepaper-66e830d72873">WHITEPAPER</a>
                            <div class="menu-item d-inline-block p-relative">
                                <span class="txt-item hover-hl">MORE</span>
                                <div class="sub-menu p-absolute">
                                    <router-link class="hover-hl" to="/upgrade">UPGRADE</router-link>
                                    <router-link class="hover-hl" to="/staking">STAKING</router-link>
                                    <router-link class="hover-hl" to="/metaverse">HALO METAVERSE</router-link>
                                    <router-link class="hover-hl" to="/protocol">PROTOCOL</router-link>
                                    <router-link class="hover-hl" to="/about">ABOUT US</router-link>
                                    <router-link class="hover-hl" to="/spark">SPARK</router-link>
                                </div>
                            </div>
                            <a class="align-top hover-path-hl social-link" href="https://twitter.com/HALONFTOFFICIAL" target="_blank">
                                <span class="align-top mobile-text">TWITTER</span>
                                <svg t="1649855498945" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="28454" width="26" height="26"><path d="M928 254.3c-30.6 13.2-63.9 22.7-98.2 26.4 35.4-21.1 62.3-54.4 75-94-32.7 19.5-69.7 33.8-108.2 41.2C765.4 194.6 721.1 174 672 174c-94.5 0-170.5 76.6-170.5 170.6 0 13.2 1.6 26.4 4.2 39.1-141.5-7.4-267.7-75-351.6-178.5-14.8 25.4-23.2 54.4-23.2 86.1 0 59.2 30.1 111.4 76 142.1-28-1.1-54.4-9-77.1-21.7v2.1c0 82.9 58.6 151.6 136.7 167.4-14.3 3.7-29.6 5.8-44.9 5.8-11.1 0-21.6-1.1-32.2-2.6C211 652 273.9 701.1 348.8 702.7c-58.6 45.9-132 72.9-211.7 72.9-14.3 0-27.5-0.5-41.2-2.1C171.5 822 261.2 850 357.8 850 671.4 850 843 590.2 843 364.7c0-7.4 0-14.8-0.5-22.2 33.2-24.3 62.3-54.4 85.5-88.2z" p-id="28455" fill="#ffffff"></path></svg>
                            </a>
                            <a class="align-top hover-path-hl social-link" href="https://discord.gg/halonft" target="_blank">
                                <span class="align-top mobile-text">DISCORD</span>
                                <svg t="1649857410229" class="icon" viewBox="0 0 1280 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1514" width="26" height="26"><path d="M1049.062 139.672a3 3 0 0 0-1.528-1.4A970.13 970.13 0 0 0 808.162 64.06a3.632 3.632 0 0 0-3.846 1.82 674.922 674.922 0 0 0-29.8 61.2 895.696 895.696 0 0 0-268.852 0 619.082 619.082 0 0 0-30.27-61.2 3.78 3.78 0 0 0-3.848-1.82 967.378 967.378 0 0 0-239.376 74.214 3.424 3.424 0 0 0-1.576 1.352C78.136 367.302 36.372 589.38 56.86 808.708a4.032 4.032 0 0 0 1.53 2.75 975.332 975.332 0 0 0 293.65 148.378 3.8 3.8 0 0 0 4.126-1.352A696.4 696.4 0 0 0 416.24 860.8a3.72 3.72 0 0 0-2.038-5.176 642.346 642.346 0 0 1-91.736-43.706 3.77 3.77 0 0 1-0.37-6.252 502.094 502.094 0 0 0 18.218-14.274 3.638 3.638 0 0 1 3.8-0.512c192.458 87.834 400.82 87.834 591 0a3.624 3.624 0 0 1 3.848 0.466 469.066 469.066 0 0 0 18.264 14.32 3.768 3.768 0 0 1-0.324 6.252 602.814 602.814 0 0 1-91.78 43.66 3.75 3.75 0 0 0-2 5.222 782.11 782.11 0 0 0 60.028 97.63 3.728 3.728 0 0 0 4.126 1.4A972.096 972.096 0 0 0 1221.4 811.458a3.764 3.764 0 0 0 1.53-2.704c24.528-253.566-41.064-473.824-173.868-669.082zM444.982 675.16c-57.944 0-105.688-53.174-105.688-118.478s46.818-118.482 105.688-118.482c59.33 0 106.612 53.64 105.686 118.478 0 65.308-46.82 118.482-105.686 118.482z m390.76 0c-57.942 0-105.686-53.174-105.686-118.478s46.818-118.482 105.686-118.482c59.334 0 106.614 53.64 105.688 118.478 0 65.308-46.354 118.482-105.688 118.482z" p-id="1515" fill="#ffffff"></path></svg>
                            </a>
                            <a class="align-top hover-path-hl social-link" href="https://opensea.io/collection/halo-official" target="_blank">
                                <span class="align-top mobile-text">OPENSEA</span>
                                <svg width="26" height="26" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M45 0C20.151 0 0 20.151 0 45C0 69.849 20.151 90 45 90C69.849 90 90 69.849 90 45C90 20.151 69.858 0 45 0ZM22.203 46.512L22.392 46.206L34.101 27.891C34.272 27.63 34.677 27.657 34.803 27.945C36.756 32.328 38.448 37.782 37.656 41.175C37.323 42.57 36.396 44.46 35.352 46.206C35.217 46.458 35.073 46.71 34.911 46.953C34.839 47.061 34.713 47.124 34.578 47.124H22.545C22.221 47.124 22.032 46.773 22.203 46.512ZM74.376 52.812C74.376 52.983 74.277 53.127 74.133 53.19C73.224 53.577 70.119 55.008 68.832 56.799C65.538 61.38 63.027 67.932 57.402 67.932H33.948C25.632 67.932 18.9 61.173 18.9 52.83V52.56C18.9 52.344 19.08 52.164 19.305 52.164H32.373C32.634 52.164 32.823 52.398 32.805 52.659C32.706 53.505 32.868 54.378 33.273 55.17C34.047 56.745 35.658 57.726 37.395 57.726H43.866V52.677H37.467C37.143 52.677 36.945 52.299 37.134 52.029C37.206 51.921 37.278 51.813 37.368 51.687C37.971 50.823 38.835 49.491 39.699 47.97C40.284 46.944 40.851 45.846 41.31 44.748C41.4 44.55 41.472 44.343 41.553 44.145C41.679 43.794 41.805 43.461 41.895 43.137C41.985 42.858 42.066 42.57 42.138 42.3C42.354 41.364 42.444 40.374 42.444 39.348C42.444 38.943 42.426 38.52 42.39 38.124C42.372 37.683 42.318 37.242 42.264 36.801C42.228 36.414 42.156 36.027 42.084 35.631C41.985 35.046 41.859 34.461 41.715 33.876L41.661 33.651C41.553 33.246 41.454 32.868 41.328 32.463C40.959 31.203 40.545 29.97 40.095 28.818C39.933 28.359 39.753 27.918 39.564 27.486C39.294 26.82 39.015 26.217 38.763 25.65C38.628 25.389 38.52 25.155 38.412 24.912C38.286 24.642 38.16 24.372 38.025 24.111C37.935 23.913 37.827 23.724 37.755 23.544L36.963 22.086C36.855 21.888 37.035 21.645 37.251 21.708L42.201 23.049H42.219C42.228 23.049 42.228 23.049 42.237 23.049L42.885 23.238L43.605 23.436L43.866 23.508V20.574C43.866 19.152 45 18 46.413 18C47.115 18 47.754 18.288 48.204 18.756C48.663 19.224 48.951 19.863 48.951 20.574V24.939L49.482 25.083C49.518 25.101 49.563 25.119 49.599 25.146C49.725 25.236 49.914 25.38 50.148 25.56C50.337 25.704 50.535 25.884 50.769 26.073C51.246 26.46 51.822 26.955 52.443 27.522C52.605 27.666 52.767 27.81 52.92 27.963C53.721 28.71 54.621 29.583 55.485 30.555C55.728 30.834 55.962 31.104 56.205 31.401C56.439 31.698 56.7 31.986 56.916 32.274C57.213 32.661 57.519 33.066 57.798 33.489C57.924 33.687 58.077 33.894 58.194 34.092C58.554 34.623 58.86 35.172 59.157 35.721C59.283 35.973 59.409 36.252 59.517 36.522C59.85 37.26 60.111 38.007 60.273 38.763C60.327 38.925 60.363 39.096 60.381 39.258V39.294C60.435 39.51 60.453 39.744 60.471 39.987C60.543 40.752 60.507 41.526 60.345 42.3C60.273 42.624 60.183 42.93 60.075 43.263C59.958 43.578 59.85 43.902 59.706 44.217C59.427 44.856 59.103 45.504 58.716 46.098C58.59 46.323 58.437 46.557 58.293 46.782C58.131 47.016 57.96 47.241 57.816 47.457C57.609 47.736 57.393 48.024 57.168 48.285C56.97 48.555 56.772 48.825 56.547 49.068C56.241 49.437 55.944 49.779 55.629 50.112C55.449 50.328 55.251 50.553 55.044 50.751C54.846 50.976 54.639 51.174 54.459 51.354C54.144 51.669 53.892 51.903 53.676 52.11L53.163 52.569C53.091 52.641 52.992 52.677 52.893 52.677H48.951V57.726H53.91C55.017 57.726 56.07 57.339 56.925 56.61C57.213 56.358 58.482 55.26 59.985 53.604C60.039 53.541 60.102 53.505 60.174 53.487L73.863 49.527C74.124 49.455 74.376 49.644 74.376 49.914V52.812V52.812Z" fill="#ffffff"/>
                                </svg>
                            </a>
                        </div>
                    </nav>
                    <div class="common-empty-area w-20" @click="toggleMenu"></div>
                </div>
            </div>
        </header>
        <main class="p-relative" :class="!isHome ? 'common-main' : ''">
            <router-view @childSetBg="childSetBg"></router-view>
        </main>
        <footer></footer>
    </div>
</template>

<script>
import { ref, watch, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import ChainApi from './sdk/ChainApi';
import { Storage } from './utils/storage';

export default {
    name: 'App',

    setup() {
        const route = useRoute();
        const isHome = ref(false);
        const whiteTextHeader = ref(false);
        const bgImg = ref(false);
        const bgClass = ref(false);
        const bgFullWrap = ref(false);
        const menuOpen = ref(false);
        const isMobile = ref(false);
        const bgImgArr = [require('./assets/images/index_bg.jpg'), require('./assets/images/protocol_bg.jpg'), require('./assets/images/spark_bg.jpg'), require('./assets/images/staking_bg.jpg'),];
        
        const initPage = () => {
            if (route.path == '/' || route.path == '/home') {
                document.title = 'HALO';
                isHome.value = true;

                bgImg.value = false;
                whiteTextHeader.value = true;
                bgFullWrap.value = true;

                if (isMobile.value) {
                    bgClass.value = 'bg-home app-mobile-home-box';
                } else {
                    bgClass.value = 'bg-home';
                }
            } else {
                document.title = 'HALO - ' + route.meta.title;

                whiteTextHeader.value = route.meta.whiteTextHeader ? true : false;
                bgImg.value = route.meta.bgImg ? bgImgArr[route.meta.bgImg - 1] : false;
                bgClass.value = route.meta.bgClass ? route.meta.bgClass : false;
                bgFullWrap.value = route.meta.bgFullWrap ? true : false;
            }
        };

        const toggleMenu = () => {
            menuOpen.value = !menuOpen.value;
        };

        const checkMobile = () => {
            let windowWidth = document.body.clientWidth || document.documentElement.clientWidth;
            if (windowWidth <= 960) {
                isMobile.value = true;
                menuOpen.value = false;
            } else {
                isMobile.value = false;
                menuOpen.value = true;
            }
        };

        const childSetBg = index => {
            if (index == 2) {
                bgClass.value = false;

                if (isMobile.value) {
                    bgClass.value = 'spark-container-bg';
                    bgImg.value = require('./assets/images/roadmap_bgm.jpg');
                    bgFullWrap.value = false;
                    whiteTextHeader.value = false;
                } else {
                    bgImg.value = require('./assets/images/roadmap_bg.jpg');
                    bgFullWrap.value = true;
                    whiteTextHeader.value = true;
                }
            } else if (index == 1 && isMobile.value) {
                bgImg.value = require('./assets/images/protocol_bg.jpg');
                bgFullWrap.value = false;
                whiteTextHeader.value = false;
                bgClass.value = false;
            } else {
                bgImg.value = false;
                bgClass.value = 'bg-secondary';
                bgFullWrap.value = false;
                whiteTextHeader.value = false;
            }
        };

        const init = () => {
            onChainStatus();
            onChainChanged();
            onAccountsChanged();
            // const connectChainType = window.localStorage.getItem('connectChainType');
            // connect(connectChainType || 'm');
        };

        const onChainStatus = () => {
            ChainApi.chainWeb3.onChainStatus(handleChainStatus);
        };

        const onChainChanged = () => {
            ChainApi.chainWeb3.onChainChanged(handleChainChanged);
        };

        const onAccountsChanged = () => {
            ChainApi.chainWeb3.onAccountsChanged(handleNewAccounts);
        };

        const handleNewAccounts = acc => {
            // if (!acc.length) {
            //     Storage.removeItem('account');
            //     return;
            // }
            let user = sessionStorage.getItem('wallet_address');
            if (acc.length) {
                if (user !== null) {
                    if (user !== acc[0]) {
                        sessionStorage.setItem('wallet_address', acc[0]);
                        window.location.reload();
                    }
                } else {
                    sessionStorage.setItem('wallet_address', acc[0]);
                }
            }
        };

        const handleChainChanged = chainId => {
            let old_chainId = sessionStorage.getItem('chain_id');
            chainId = Number(chainId).toString(16);
            // console.error('handleChainChanged:', old_chainId, chainId)
            sessionStorage.setItem('chain_id', chainId);
            /*
            if (old_chainId && old_chainId != chainId) {
                window.location.reload();
            }
            */
        };

        const handleChainStatus = status => {
            if (status === 2) {
                //console.log('connect success');
                // this.$store.commit('isInstall', true);
                // this.isOpen = !this.account;
            } else {
                //console.log('no install')
                // this.$store.commit('isInstall', false);
                // this.isOpen = true;
            }
        };

        onMounted(() => {
            if(window.top != window.self){
                top.location.href = document.location.href;
            }
            
            setTimeout(() => {
                checkMobile();
                initPage();
                init();
            }, 100);
            window.addEventListener('resize', () => {
                checkMobile();
            });
        });

        watch(
            () => route.path,
            () => {
                window.scroll(0, 0);
                checkMobile();
                if (isMobile.value) {
                    menuOpen.value = false;
                }
                if (route.path == '/' || route.path == '/home') {
                    isHome.value = true;
                } else {
                    isHome.value = false;
                }
                initPage();
            }
        );

        return {
            isHome,
            whiteTextHeader,
            bgImg,
            bgClass,
            bgFullWrap,
            menuOpen,
            toggleMenu,
            childSetBg,
            isMobile,
        };
    },
};
</script>

<style>
#app {
    font-family: 'CrimsonTextRoman';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000;
    height: 100%;
}

.app-box {
    min-height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    background-attachment: fixed;
    padding-top: 65px;
}

.bg-position-bottom-center {
  background-position: bottom center;
}

#header {
    padding: 10px 0;
    top: 0;
    left: 0;
    z-index: 3;
    height: 65px;
}

.nav {
    padding-top: 15px;
    padding-right: 20px;
}

.logo {
    height: 30px;
}

.menu a,
.menu .txt-item {
    border-radius: 5px;
    color: #fff;
    font-size: 14px;
    font-weight: 100;
    margin-left: 15px;
    padding: 5px 10px;
    position: relative;
    text-decoration: none;
    cursor: pointer;
}

.menu img {
    height: 15px;
    vertical-align: middle;
    position: relative;
    top: -2px;
}

.menu-item .sub-menu {
    display: none;
    width: 220%;
    left: -60%;
    top: 20px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 5px;
    padding: 5px 0;
    z-index: 2;
}

.menu-item:hover .sub-menu {
    display: block;
}

.menu-item .sub-menu a {
    width: 100%;
    display: block;
    margin-left: 0;
    text-align: center;
}

.menu .social-link {
    margin-left: 10px;
}

.black-menu a,
.black-menu .txt-item  {
    color: #000;
}

.black-menu path {
    fill: #000;
}

.nav-toggle-btn,
.common-empty-area {
    display: none;
}

.menu-toggle-btn,
.close-menu-btn,
.mobile-text {
    display: none;
}

@media screen and (max-width: 1500px) {
}

@media screen and (max-width: 960px) {
    #header {
        height: 65px;
        z-index: 4;
    }

    .logo-link {
        margin-left: 60px;
    }

    .mobile-img-hack {
        display: block !important;
        position: fixed;
        z-index: 0;
        top: 0;
        left: 0;
        background-position: center 0;
        background-repeat: no-repeat;
        background-size: cover;
        width: 100%;
        height: 100vh;
    }

    .spark-container-bg .mobile-img-hack {
        background-size: 150% auto;
    }

    .app-box {
        padding-top: 0px;
    }

    .app-mobile-home-box {
        padding-top: 0;
    }

    .nav-toggle-btn {
        display: inline;
        left: 6px;
        z-index: 12;
    }

    .home-nav-toggle-btn {
        right: auto;
        top: 20px;
        left: 10px;
    }

    .home-nav-toggle-btn path,
    .nav-toggle-btn .fill-white path {
        fill: #fff;
    }

    .common-menu-box {
        display: block;
        position: fixed;
        background: rgba(0, 0, 0, 0.2);
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        z-index: 10;
    }

    .common-menu-box .common-empty-area {
        display: block;
    }

    .common-empty-area,
    .common-menu {
        height: 100vh;
    }

    .common-menu-box .common-menu {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        display: block;
        padding-top: 60px;
        width: 80%;
    }

    .common-menu-box .nav-box {
        background: #fff;
    }

    .nav .menu {
        width: 100%;
    }

    .menu a:before,
    .menu .txt-item:before {
        background: #1d1d1d;
        content: "";
        width: 10px;
        height: 10px;
        border-radius: 10px;
        position: absolute;
        top: 10px;
        left: -20px;
    }

    .sub-menu a:before {
        width: 0;
        height: 0;
    }

    .page-menu-box a:before {
        top: 15px;
    }

    .menu a,
    .menu .txt-item {
        color: #000;
        display: block;
        position: relative;
    }

    .menu a,
    .menu .txt-item,
    .menu .social-link {
        height: 50px;
        margin-left: 40px;
        font-size: 20px;
    }

    .menu .mobile-text {
        display: inline;
    }

    .menu-item .sub-menu {
        padding-top: 0;
        display: none;
        left: 170px;
        top: -5px;
        background: none;
        width: 130px;
    }

    .menu-item .sub-menu a {
        line-height: 1.1rem;
    }

    .home-menu-box a {
        display: inline;
        margin-left: 0;
    }

    .home-menu-box .social-link {
        margin-left: 0;
    }

    .menu .social-link svg {
        position: relative;
        margin-left: 10px;
        top: 5px;
    }

    .page-menu-box .social-link svg {
        top: 0;
    }

    .menu .social-link svg.opensea-icon {
        left: -5px;
    }

    .external-links {
        margin-left: 0;
        margin-top: 30px;
    }

    .white-external-links a path {
        fill: #e3127a;
    }

    .menu-toggle-btn {
        display: inline;
        padding: 5px;
        right: 10px;
        top: -5px;
    }

    .close-menu-btn {
        top: 10px;
        right: 10px;
        display: block;
    }

    .home-logo-link {
        position: fixed;
        bottom: 30px;
        left: 30px;
    }

    .home-logo-link .logo {
        height: 40px;
    }

    .home-menu-box .common-empty-area {
        display: none;
    }

    .home-menu-box {
        position: absolute;
        top: 15px;
        left: 0;
        background: none;
        height: auto;
        width: 60%;
    }

    .home-menu-box .common-menu {
        width: 100%;
        height: auto;
        background: none;
    }

    .home-menu-box a {
        padding: 2px 5px;
        font-size: 20px;
        color: #1d1d1d;
    }

    .page-menu-box .nav {
        animation: slideLeft 0.2s linear;
        -webkit-animation: slideLeft 0.2s linear;
        position: relative;
    }

    @keyframes slideLeft {
        0% {
            transform: translateX(-200px);
            opacity: 0;
        }
        100% {
            transform: translateX(0px);
            opacity: 1;
        }
    }

    .home-menu-box .nav {
        animation: slideDown 0.1s linear;
        -webkit-animation: slideDown 0.1s linear;
        position: relative;
    }

    @keyframes slideDown {
        0% {
            transform: translateY(-50px);
            opacity: 0;
        }
        100% {
            transform: translateY(0);
            opacity: 1;
        }
    }

    main {
        padding-top: 60px;
    }

    .home-main {
        margin-top: 0;
    }
}
</style>
